module.exports = __webpack_public_path__ + "img/black2.76946706.svg";